import React, { Fragment } from 'react'
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import propTypeSchema from 'react-json-schema-proptypes'
import Radium from 'radium'
import { BasicDonorInfo, Card } from '../types'
import { valueOrUndefined } from '../common'
import Phone from 'phone'

const schema = {
  'type': 'object',
  'properties': {
    'type': {'enum': ['alpha']},
    'firstNameLabel': {'type': 'string'},
    'lastNameLabel': {'type': 'string'},
    'emailLabel': {'type': 'string'},
    'mobileNumberLabel': {'type': 'string'},
    'titleColor': {'type': 'string'},
    'mobileBreakPoint': {'type': 'number'},
    'mobileMaxWidth': {'type': 'number'},
    'mobileRequired': {'type': 'boolean'},
  }
}

@Radium
export default class AlphaDonorInfo extends React.PureComponent {
  static propSchema = schema

  static propTypes = propTypeSchema(schema, {
    'required': ['onInfoChanged'],
    'properties': {
      'values': BasicDonorInfo.Schema,
      'displayErrors': {'type': 'boolean'},
      'onInfoChanged': {'isFunction': true},
      'onValidChanged': {'isFunction': true},
      'cards': {'type': 'array', 'items': Card.Schema},
      'selectedCard': Card.Schema
    }
  })

  static defaultProps = {
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    emailLabel: 'Email Address',
    mobileNumberLabel: 'Mobile Number',
    mobileBreakPoint: 768,
    mobileMaxWidth: 900,
    mobileRequired: false,
  }

  constructor (props) {
    super(props)
    this.state = {
      formErrors: {
        firstName: props.values.firstName ? null : 'Required',
        lastName: props.values.lastName ? null : 'Required',
        email: props.values.email ? null : 'Required',
        mobileNumber: props.values.mobileNumber || this.props.mobileRequired !== "true" ? null :'Required',
      }
    }
  }

  handleUserInput = (e) => {
    const name = e.target.name
    const value = e.target.value
    this.props.onInfoChanged({[name]: value})
  }

  validateField = (fieldName, value) => {
    const fieldValidationErrors = {}
    switch (fieldName) {
      case 'email':
        fieldValidationErrors.email = value && value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? null : 'Not a valid email'
        break
      case 'firstName':
        fieldValidationErrors.firstName = value && value.length > 0 ? null : 'Required'
        break
      case 'lastName':
        fieldValidationErrors.lastName = value && value.length > 0 ? null : 'Required'
        break
      case 'mobileNumber':
        if (this.props.mobileRequired === "true") {
          fieldValidationErrors.mobileNumber = (!value || value.length === 0) ? 'Required' : Phone(value)[0] ? null : 'Not a valid phone number'
        } else {
          fieldValidationErrors.phoneNumber = !value || value.length === 0 || Phone(value)[0] ? null : 'Not a valid phone number'
        }
        break
      default:
        break
    }

    this.setState(state => {
      return {
        formErrors: {
          ...state.formErrors,
          ...fieldValidationErrors
        }
      }
    }, () => this.props.onValidChanged(this.allValid()))
  }

  allValid = () => {
    return (!this.state.formErrors.email && !this.state.formErrors.firstName && !this.state.formErrors.lastName && !this.state.formErrors.email && !this.state.formErrors.mobileNumber) || !!this.props.selectedCard
  }

  checkValidateField = (prevProps, fieldName) => {
    if (valueOrUndefined(this.props, `values.${fieldName}`) !== valueOrUndefined(prevProps, `values.${fieldName}`)) {
      this.validateField(fieldName, valueOrUndefined(this.props, `values.${fieldName}`))
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.values !== prevProps.values) {
      this.checkValidateField(prevProps, 'firstName')
      this.checkValidateField(prevProps, 'lastName')
      this.checkValidateField(prevProps, 'email')
      this.checkValidateField(prevProps, 'mobileNumber')
    }
  }

  componentDidMount () {
    this.props.onValidChanged(this.allValid())
  }

  render () {
    const styles = {
      breakPointStyle: {},
      title: {
        color: valueOrUndefined(this.props, 'titleColor')
      },
    }
    if (this.props.mobileMaxWidth) {
      styles['breakPointStyle'][`@media (max-width: ${this.props.mobileBreakPoint - 1}px)`] = {
        maxWidth: this.props.mobileMaxWidth,
        marginLeft: "auto",
        marginRight: "auto"
      }
    }
    return (
      <div className='alpha' style={[styles.breakPointStyle]}>
        {this.props.cards.length === 0 &&
        <Fragment>
        <hr />
        <div>
          <Row>
            <Col xs={12} className='donorInfo' style={styles.title}>
              Donor Information
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <FormGroup
                className={'infoEntry' + (this.props.displayErrors && this.state.formErrors.firstName ? ' has-error' : '')}
                controlId='firstName'>
                <ControlLabel>
                  {this.props.firstNameLabel}
                  <span> *</span>
                </ControlLabel>
                {this.props.displayErrors && this.state.formErrors.firstName &&
                <div className='formError'>&nbsp;{this.state.formErrors.firstName}</div>
                }
                <FormControl
                  name='firstName'
                  id='firstName'
                  type='text'
                  value={valueOrUndefined(this.props, 'values.firstName')}
                  onChange={this.handleUserInput}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <FormGroup
                className={'infoEntry' + (this.props.displayErrors && this.state.formErrors.lastName ? ' has-error' : '')}
                controlId='lastName'>
                <ControlLabel>
                  {this.props.lastNameLabel}
                  <span> *</span>
                </ControlLabel>
                {this.props.displayErrors && this.state.formErrors.lastName &&
                <div className='formError'>&nbsp;{this.state.formErrors.lastName}</div>
                }
                <FormControl
                  name='lastName'
                  id='lastName'
                  type='text'
                  value={valueOrUndefined(this.props, 'values.lastName')}
                  onChange={this.handleUserInput} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <FormGroup
                className={'infoEntry' + (this.props.displayErrors && this.state.formErrors.email ? ' has-error' : '')}
                controlId='email'>
                <ControlLabel>
                  {this.props.emailLabel}
                  <span> (required for receipt)</span>
                  <span> *</span>
                </ControlLabel>
                {this.props.displayErrors && this.state.formErrors.email &&
                <div className='formError'>&nbsp;{this.state.formErrors.email}</div>
                }
                <FormControl
                  name='email'
                  id='email'
                  type='text'
                  value={valueOrUndefined(this.props, 'values.email')}
                  onChange={this.handleUserInput} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <FormGroup
                className={'infoEntry last' + (this.props.displayErrors && this.state.formErrors.mobileNumber ? ' has-error' : '')}
                controlId='mobileNumber'>
                <ControlLabel>
                  {this.props.mobileNumberLabel} { this.props.mobileRequired === "true" ? "*" : "" }
                </ControlLabel>
                {this.props.displayErrors && this.state.formErrors.mobileNumber &&
                <div className='formError'>&nbsp;{this.state.formErrors.mobileNumber}</div>
                }
                <FormControl
                  name='mobileNumber'
                  id='mobileNumber'
                  type='text'
                  value={valueOrUndefined(this.props, 'values.mobileNumber')}
                  onChange={this.handleUserInput} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <hr />
            </Col>
          </Row>
        </div>
        </Fragment>
        }
        {this.props.cards.length > 0 && <div className={'bottomMargin'}/>}
      </div>
    )
  }
}
